<template>
    <!-- <div id="services" class="px-10 tablet:px-16 xl:px-24 pb-16"> -->
    <div class="px-10 lg:px-20 xl:px-32 pb-16 max-w-full" id="services">
        <h1 class="text-4xl tablet:text-5xl font-bold text-center text-white p-6 uppercase">
            {{ tr('whatDoWeDo.title') }}
        </h1>
        <div class="flex flex-row flex-wrap qhd:flex-no-wrap justify-between text-white font-bold text-xl md:text-2xl">

            <div class="w-full md:w-6/12 tablet:w-auto">
                <div class="flex flex-col items-start justify-around flex-wrap h-full">
                    <WhatDoWeDoItem v-for="(item, id) in items(0)" :data="item" :key="id"/>
                </div>
            </div>

            <div class="w-full md:w-6/12 tablet:w-auto lg:w-auto">
                <div class="flex flex-col items-start justify-around flex-wrap mx-auto h-full">
                    <WhatDoWeDoItem v-for="(item, id) in items(1)" :data="item" :key="id"/>
                </div>
            </div>

            <div class="w-full md:w-5/12 tablet:w-auto lg:w-auto tablet:mt-0 md:mt-10 md:mt-0">
                <div
                    class="flex flex-col items-start lg:items-start justify-start tablet:justify-around flex-wrap mx-auto h-full"
                >
                    <WhatDoWeDoItem v-for="(item, id) in items(2)" :data="item" :key="id"/>
                </div>
            </div>


            <div
                class="self-end flex flex-col w-full items-center md:w-6/12 tablet:w-6/12 qhd:w-4/12 tablet:mx-auto qhd:mx-0 pt-12">
                <div class="w-full mb-8">
                    <img alt=""
                         class="object-contain w-full h-full shadow-xl" :src="'/img/public/whatDoWeDo/office.jpg'">
                </div>
                <div
                    class="whitespace-no-wrap lg-16 tablet:mt-0 uppercase font-extrabold font-condensed self-center md:self-auto">
                    <div
                        class="bg-white p-3 pt-1 pb-1 sm:text-xl text-2xl tablet:text-3xl transparentText text-black cursor-pointer inline-block elementHoverShadow"
                        v-on:click="navigateTo('#references')"
                    >
                        {{ tr('whatDoWeDo.ourProjects') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';
import WhatDoWeDoItem from './baseComponents/WhatDoWeDoItem';

export default {
    name: 'WhatDoWeDo',
    mixins: [Translatable],
    components: {WhatDoWeDoItem},
    methods: {
        navigateTo(key) {
            this.$emit('navigate-to', key);
        },
        items(column) {
            return this.tr('whatDoWeDo.items')[column];
        },
    },
};
</script>

<style scoped>
#services {
    background: linear-gradient(rgb(7, 7, 7), rgb(102, 102, 102));
    width: 100vw;
}

#transparentText {
    font-weight: 800;
    font-size: 7rem;
    line-height: 7rem;
}


</style>
